import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_kober-energy/artifacts/vys7c9cr_3.png";

function LegalHeader({ c, lang, setLang, testIdPrefix, onNavigate }) {
  return (
    <header className="bg-black/60 backdrop-blur-xl border-b border-white/8 sticky top-0 z-40">
      <div className="container mx-auto px-6 lg:px-12 max-w-5xl h-20 flex items-center justify-between">
        <button onClick={onNavigate} data-testid={`${testIdPrefix}-back-btn`}
          className="flex items-center gap-2.5 text-sm text-white/50 hover:text-[#D4A017] transition-colors duration-200 group">
          <ArrowLeft size={15} className="group-hover:-translate-x-0.5 transition-transform duration-200" />
          {c.back}
        </button>
        <img src={LOGO_URL} alt="KÖBER Energy Holding" className="h-10 w-auto" />
        <div className="flex items-center gap-1 text-sm" data-testid={`${testIdPrefix}-lang-toggle`}>
          {['EN', 'RO'].map((l, i) => (
            <span key={l} className="flex items-center gap-1">
              {i > 0 && <span className="text-white/20 text-xs">/</span>}
              <button onClick={() => setLang(l)}
                className={`px-2 py-1 font-medium transition-colors ${lang === l ? 'text-[#D4A017]' : 'text-white/40 hover:text-white/70'}`}>
                {l}
              </button>
            </span>
          ))}
        </div>
      </div>
    </header>
  );
}

function LegalSectionList({ sections, testIdPrefix }) {
  return (
    <div className="space-y-10">
      {sections.map((section, i) => (
        <div key={section.heading} className="grid grid-cols-1 lg:grid-cols-4 gap-4 lg:gap-10 pb-10 border-b border-white/6 last:border-0">
          <div className="lg:col-span-1">
            <h2 className="text-base font-medium text-[#D4A017] leading-snug" style={{ fontFamily: "'Outfit', sans-serif" }}
              data-testid={`${testIdPrefix}-section-${i}`}>
              {section.heading}
            </h2>
          </div>
          <div className="lg:col-span-3">
            <p className="text-sm text-white/65 leading-relaxed whitespace-pre-line">{section.body}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export function LegalPageLayout({ c, lang, setLang, testIdPrefix }) {
  const navigate = useNavigate();
  const goHome = () => navigate('/');
  return (
    <div className="bg-[#050505] min-h-screen text-white" style={{ fontFamily: "'Manrope', sans-serif" }}>
      <div className="h-0.5 bg-gradient-to-r from-[#D4A017] via-[#D4A017]/40 to-transparent" />
      <LegalHeader c={c} lang={lang} setLang={setLang} testIdPrefix={testIdPrefix} onNavigate={goHome} />
      <main className="container mx-auto px-6 lg:px-12 max-w-5xl py-16 sm:py-24">
        <div className="mb-14 pb-10 border-b border-white/8">
          <p className="text-xs tracking-[0.28em] uppercase text-[#D4A017] mb-4 font-medium">Legal</p>
          <h1 className="text-4xl sm:text-5xl font-medium text-white mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>{c.title}</h1>
          <p className="text-sm text-white/35">{c.updated}</p>
        </div>
        <LegalSectionList sections={c.sections} testIdPrefix={testIdPrefix} />
        <div className="mt-16 pt-8 border-t border-white/8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-white/25">© KOBER Energy. All rights reserved.</p>
          <button onClick={goHome} className="text-xs text-[#D4A017] hover:text-[#F5B814] transition-colors flex items-center gap-1.5">
            <ArrowLeft size={11} /> {c.back}
          </button>
        </div>
      </main>
    </div>
  );
}
